import $ from 'jquery'

/**
 * This plugins ensures the first letter in an input is always uppercased
 */
$.widget('ui.upperCaseFirstLetter', {
  _create () {
    this.element.on('input', this.upperCaseFirstLetter.bind(this))
  },
  upperCaseFirstLetter () {
    const value = this.element.val()
    this.element.val(value[0].toUpperCase() + value.substr(1))
  },
})



// WEBPACK FOOTER //
// ./src/plugins/jquery.uppercase-first-letter.js